import {
  Box,
  Button,
  Chip,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { DateTime } from "luxon";
import { utcToZonedTime } from "date-fns-tz";
import React, { useState } from "react";
import QCModal from "../../components/QCModal";
import moment from "moment";

// New MatchStatus:
// INACTIVE = 0
// MATCH_CREATED = 1
// VIDEO_UPLOADED = 2
// ANALYSIS_DONE = 3
// RESOURCES_ASSIGNED = 4
// ANALYSIS_IN_PROGRESS = 5
// REVIEW_IN_PROGRESS = 6
// COMPLETED = 7
// MARK_FOR_REVIEW = 8
// ISSUE_FOUND = 9

export const STATUS_MAP = {
  0: "Inactive",
  1: "Match Created",
  2: "Video Uploaded",
  3: "Analysis Done",
  4: "Resources Assigned",
  5: "Analysis In-Progress",
  6: "Review In-Progress",
  7: "COMPLETED",
  8: "Mark For Review",
  9: "Issue Found",
};

export const MatchCard = ({ data, onEditPress, viewRef }) => {
  const [isQcModalOpen, setIsQcModalOpen] = useState(false);
  if (!data) {
    return null;
  }

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${hrs.toString()}hrs,${mins.toString()}mins`;
  };

  const formatTimeFromSecondsToMinutes = (seconds) => {
    const mins = Math.floor(seconds / 60);
    return `${mins.toString()}mins`;
  };

  const formatDateAndTime = (dateWithTime) => {
    const _dateWithTime = dateWithTime?.replace(" ", "T");
    if (_dateWithTime) {
      const utcTime = DateTime.fromISO(_dateWithTime, { zone: "utc" });
      const istTime = utcToZonedTime(utcTime.toJSDate(), "Asia/Kolkata");

      return format(istTime, "PPpp");
    } else {
      return "NA";
    }
  };

  let statusBorderColor = "";

  switch (data?.status) {
    case 0:
      statusBorderColor = "rgba(109, 117, 128, 1)";
      break;
    case 1:
      statusBorderColor = "rgba(109, 117, 128, 1)";
      break;
    case 2:
      statusBorderColor = "rgba(46, 90, 172, 1)";
      break;
    case 3:
      statusBorderColor = "rgba(40, 125, 60, 1)";
      break;
    case 4:
      statusBorderColor = "rgba(46, 90, 172, 1)";
      break;
    case 5:
      statusBorderColor = "rgba(46, 90, 172, 1)";
      break;
    case 6:
      statusBorderColor = "rgba(46, 90, 172, 1)";
      break;
    case 7:
      statusBorderColor = "rgba(40, 125, 60, 1)";

      break;
    case 8:
      statusBorderColor = "rgba(40, 125, 60, 1)";

      break;
    case 9:
      statusBorderColor = "rgba(218, 20, 20, 1)";

      break;
  }

  return (
    <>
      <QCModal
        setIsQcModalOpen={setIsQcModalOpen}
        modalIsOpen={isQcModalOpen}
        matchId={data.id}
      />
      <TableRow ref={viewRef} hover>
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 888,
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              backgroundColor: "#fff",
            },
          }}
          component="th"
          scope="row"
        >
          {data.id}
        </TableCell>

        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
              py: 2,
            },
          }}
        >
          {data?.team_a_details?.name}
          <br />
          <Typography
            sx={{
              color: "blue",
              opacity: 0.7,
              lineHeight: "120%",
              fontSize: "12px",
            }}
          >
            vs
            <br />
          </Typography>
          {data?.team_b_details?.name}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Stack
            justifyContent="center"
            alignItems="center"
            direction="row"
            flexWrap="wrap"
          >
            {data?.analyst_details?.map((item, index) => (
              <Chip
                key={item.id}
                label={`${item?.name}`}
                sx={{ borderRadius: 1, fontSize: "small", margin: 1 }}
              />
            ))}
            {!data.analyst_details.length && (
              <Chip
                label={"No Analyst"}
                sx={{ borderRadius: 1, fontSize: "small", margin: 1 }}
              />
            )}
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "left",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          {data?.analysis_sense_data?.assigned_date
            ? moment(data?.analysis_sense_data?.assigned_date)?.format(
                "MMM DD, YYYY[\n]hh:mm A"
              )
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "left",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          {data?.analysis_sense_data?.analysis_start_time
            ? moment(data?.analysis_sense_data?.analysis_start_time)?.format(
                "MMM DD, YYYY[\n]hh:mm A"
              )
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          <Box
            sx={{
              p: "2px",
              border: "0.5px solid #e1e1e1",
              bgcolor: "#e1e1e160",
              borderRadius: "4px",
            }}
          >
            {data?.analysis_sense_data?.analysis_progress || "NA"}
          </Box>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "right",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          {data?.analysis_sense_data?.analysis_end_time
            ? moment(data?.analysis_sense_data?.analysis_end_time)?.format(
                "MMM DD, YYYY[\n]hh:mm A"
              )
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "right",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          {data?.analysis_sense_data?.current_analysis_time
            ? moment(data?.analysis_sense_data?.current_analysis_time)?.format(
                "MMM DD, YYYY[\n]hh:mm A"
              )
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "right",
              lineHeight: "120%",
              minWidth: "100px",
            },
          }}
        >
          {data?.analysis_sense_data?.due_date
            ? moment(data?.analysis_sense_data?.due_date).format(
                "MMM DD, YYYY[\n]hh:mm A"
              )
            : "NA"}
        </TableCell>

        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Typography
            sx={{
              border: "1px solid",
              borderColor: statusBorderColor,
              padding: 0.5,
              borderRadius: "2px",
              color: statusBorderColor,
              fontWeight: 600,
              fontSize: { lg: "12px", md: "10px", xs: "8px" },
            }}
          >
            {STATUS_MAP[data?.status] || "NA"}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
          >
            {data?.reviewer_details?.map((item) => (
              <Chip
                key={item.id}
                label={`${item?.name}`}
                sx={{ borderRadius: 1, fontSize: "small", margin: 0.2 }}
              />
            ))}
            {!data.reviewer_details.length && (
              <Chip
                label={"No Reviewer"}
                sx={{ borderRadius: 1, fontSize: "small", margin: 0.2 }}
              />
            )}
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
          >
            {data?.organizer_details?.map((item) => (
              <Chip
                key={item.id}
                label={`${item?.id} - ${item?.name}`}
                sx={{ borderRadius: 1, m: 0.2, fontSize: 12 }}
              />
            )) || "NA"}
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          {data?.analysis_tat
            ? formatTimeFromSeconds(data?.analysis_tat)
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          {data?.overall_tat ? formatTimeFromSeconds(data?.overall_tat) : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          {data?.game_time ? `${data?.game_time}mins` : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          {data?.youtube_videos?.[0]?.total_video_duration
            ? formatTimeFromSecondsToMinutes(
                data?.youtube_videos?.[0]?.total_video_duration
              )
            : "NA"}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Button
            onClick={onEditPress}
            variant="contained"
            size="small"
            color="primary"
          >
            EDIT
          </Button>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "12px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              textAlign: "center",
              lineHeight: "120%",
            },
          }}
        >
          <Button
            onClick={() => setIsQcModalOpen(true)}
            variant="contained"
            size="small"
            color="primary"
          >
            QC
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};
